// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"415":"snapshot-image","835":"photo-zip"}[chunkId] + "." + {"415":"bbaa0f5b","835":"21ab9016"}[chunkId] + ".chunk.js";
};